import { get, put } from '@aiptyg/api-client';
import type { WelfarePopupConfigDTO, WelfarePopupUpdateParams } from '../types/welfare-popup.types';
export const getWelfarePopup = () => get<WelfarePopupConfigDTO>('/v1/admin/settings/welfare-popup');
export const updateWelfarePopup = (params: WelfarePopupUpdateParams) => put<WelfarePopupConfigDTO>('/v1/admin/settings/welfare-popup', params);
